"use client";

import React, { FC } from "react";
import Image from "next/image";
import { getFullUrl } from "../../../../trading-mall/src/utils/helper";
export interface BFLApiFailureTrackingConfig {
  sectionTitle?: string;
  componentPosition?: string;
  entryPoint?: string;
  productCategory?: string;
  subSection?: string;
  segmentName?: string;
  journeyTag?: string;
  campaignName?: string;
  sprint?: string;
  referenceId?: string;
  customerId?: string;
}

export type BFLApiFailureRetryClickParams = BFLApiFailureTrackingConfig & {
  ctaText: string;
};

interface BFLApiFailureProps {
  imageSrc?: string;
  imageAlt?: string;
  error?: string;
  errorDescription?: string;
  retryButtonText?: string;
  onRetry?: () => void;
  className?: string;
  trackingConfig?: BFLApiFailureTrackingConfig;
  onRetryClick?: (params: BFLApiFailureRetryClickParams) => void | Promise<void>;
}

const BFLApiFailure: FC<BFLApiFailureProps> = ({
  imageSrc = "https://thumbs.dreamstime.com/b/warning-stamp-26404148.jpg",
  imageAlt = "Error Image",
  error = "Unable to fetch the information at this time",
  errorDescription = "Something went wrong, please wait a moment, then try again",
  retryButtonText = "Retry",
  onRetry,
  className = "",
  trackingConfig,
  onRetryClick,
}) => {
  const handleRetryClick = () => {
    if (trackingConfig && onRetryClick) {
      (async () => {
        await onRetryClick({
          ctaText: retryButtonText,
          sectionTitle: trackingConfig.sectionTitle ?? error,
          componentPosition: trackingConfig.componentPosition,
          entryPoint: trackingConfig.entryPoint,
          productCategory: trackingConfig.productCategory,
          subSection: trackingConfig.subSection,
          segmentName: trackingConfig.segmentName,
          journeyTag: trackingConfig.journeyTag,
          campaignName: trackingConfig.campaignName,
          sprint: trackingConfig.sprint,
          referenceId: trackingConfig.referenceId,
          customerId: trackingConfig.customerId,
        });
      })();
    }
    onRetry?.();
  };

  return (
    <div className={`flex flex-col items-center justify-center gap-[12px] max-sm:gap-[8px] ${className}`}>
      <Image
        src={getFullUrl(imageSrc)}
        alt={imageAlt}
        width={135}
        height={160}
        loading="lazy"
        className="w-[135px] h-[160px] max-sm:w-[68px] max-sm:h-[90px]"
      />
      <p className="text-center text-black text-[20px] font-[500] max-w-[300px] max-sm:text-[12px] leading-none">
        {error}
      </p>
      <p className="text-center text-[#666666] text-[16px] font-[400] leading-[24px] max-sm:text-[12px] max-sm:leading-[16px]">
        {errorDescription}
      </p>
      <button
        onClick={handleRetryClick}
        className="text-[14px] text-[#FF6700] cursor-pointer font-[500] leading-[18px]"
        aria-label={`${retryButtonText} button`}
      >
        {retryButtonText}
      </button>
    </div>
  );
};

export default BFLApiFailure;
